/** Public environment variables (VITE_* prefix). Available in both SSR and client. */
import { Schema } from "effect";

import { SentryDsn, Url } from "@speech-agent/common";

const ClientEnvSchema = Schema.Struct({
  VITE_BASE_URL: Url,
  VITE_BETTER_AUTH_URL: Url,
  VITE_ENVIRONMENT: Schema.String,
  VITE_SENTRY_DSN: Schema.optional(SentryDsn),
  VITE_VERSION: Schema.String,
  /**
   * Origin (no path) for the speech-agent WebSocket proxy server. In dev this
   * points at the standalone ws-server (e.g. http://localhost:3001) because
   * Vite's http-proxy can't pump WebSockets on Bun's runtime. Leave empty in
   * production — the WS endpoint is then same-origin under wss://.
   */
  VITE_SPEECH_AGENT_WS_ORIGIN: Schema.optionalWith(
    Schema.String,
    {
      default: () => "",
    }
  ),
});

export const env = Schema.decodeUnknownSync(
  ClientEnvSchema
)(import.meta.env);
